var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAIcon = function SvgAIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F5F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7951 25.064C13.7951 25.64 14.2451 26.09 14.8211 26.09C15.2891 26.09 15.6671 25.838 15.8471 25.388L16.9091 22.958H23.0291L24.0551 25.316C24.2531 25.784 24.6131 26.09 25.1351 26.09C25.7291 26.09 26.1791 25.622 26.1791 25.028C26.1791 24.884 26.1431 24.722 26.0531 24.56L21.3731 14.12C21.1211 13.562 20.6891 13.22 20.0591 13.22H19.9511C19.3211 13.22 18.8711 13.562 18.6191 14.12L13.9391 24.56C13.8491 24.74 13.7951 24.902 13.7951 25.064ZM17.7551 20.996L19.9691 15.902L22.1831 20.996H17.7551Z",
    fill: "#171A20"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/a-icon.336795ceabb0b23e2e153a5489308c8b.svg";